export const questions = [
"What is the best flavour of timtams?",
"Name an intern?",
"Name a canva mural",
"If Mel could have a super power, what would it be?",
"Name a canva dog",
"Name a popular game on mobile"
];

export const data = [
  [
{"ans": "Milk", "score":50},
{"ans": "White", "score":49}, 
{"ans": "vanilla", "score":25}, 
{"ans": "caramel", "score":15},
{"ans": "doublecoat", "score":5}
]
,
[
  {"ans": "Nivaaz", "score":50},
  {"ans": "Josh", "score":49}, 
  {"ans": "Eddie", "score":25}, 
  {"ans": "Nick", "score":15},
  {"ans": "Tammy", "score":5},
  {"ans": "Jessica", "score":5}
  ]
  ,
[
{"ans": "Monkey", "score":50},
{"ans": "Rocket", "score":49}, 
{"ans": "Chocolate", "score":35}, 
{"ans": "bin", "score":15},
{"ans": "Chickem", "score":5}
]
,
[
{"ans": "speed", "score":50},
{"ans": "throughparency", "score":49}, 
{"ans": " canva", "score":5}, 
{"ans": "fast eating", "score":5},
{"ans": "story telling", "score":5}
]
,
[
{"ans": "dog", "score":50},
{"ans": "puppy", "score":49}, 
{"ans": "charlie canva", "score":5}, 
{"ans": "molly", "score":5},
{"ans": "beans", "score":5}
]
,
[
{"ans": "canva", "score":50},
{"ans": "canva", "score":49}, 
{"ans": "bongmonkey canva", "score":5}, 
{"ans": "rama", "score":5},
{"ans": "doublecoat", "score":5}
]
,

[
  {"ans": "canva", "score":50},
  {"ans": "canva", "score":49}, 
  {"ans": "bong monkey canva", "score":5}, 
  {"ans": "banana", "score":5},
  {"ans": "doublecoat", "score":5}
  ]
  ,
];

